export enum ItemStates {
    Undef = 0,
    None = 1,
    Create = 2,
    Edit = 3,
    Deleting = 4,
    Deleted = 5
}
